import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getParent, types } from 'mobx-state-tree';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
const getExistingPortfoliosAsync = createAsync(() => {
  return async function getExistingPortfolios(options) {
    const resp = await api.Portfolios.getExistingPortfolios(options);
    if (resp.isSuccessful) {
      var _singleElementOfArray;
      /* NOTE:
        It's for handling admin case,
        when admin logs in company that doesn't have any properties added yet
        we will not receive any portfolio id so it should be defined as empty
        to prevent fetching properties of previous company because id wasn't cleared
      */
      localStorage.setItem('livable_portfolio_id', ((_singleElementOfArray = singleElementOfArray(resp.response)) === null || _singleElementOfArray === void 0 ? void 0 : _singleElementOfArray.key) || '');
    }
    return resp;
  };
});
const getPortfolioAsync = createAsync(body => {
  return async function getPortfolio(options) {
    const resp = await api.Portfolios.getPortfolio(body, options);
    return resp;
  };
});
const createPortfolioAsync = createAsync(body => {
  return async function createPortfolio(options) {
    const resp = await api.Portfolios.createPortfolio(body, options);
    return resp;
  };
});
const updatePortfolioAsync = createAsync(body => {
  return async function updatePortfolio(options) {
    const resp = await api.Portfolios.updatePortfolio(body, options);
    return resp;
  };
});
const deletePortfolioAsync = createAsync(body => {
  return async function deletePortfolio(options) {
    const resp = await api.Portfolios.deletePortfolio(body, options);
    return resp;
  };
});
const getPortfoliosDashboardAsync = createAsync(function () {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      storeCompany: false
    },
    storeCompany = _ref.storeCompany;
  return async function getPortfoliosDashboard(options) {
    var _resp$response;
    const resp = await api.Portfolios.getPortfoliosDashboard(options);

    // NOTE: need to be removed, keeping for testing and proving that nothing brakes
    // getParent(this).properties.setActivePortfolioItemsAfterLoad(resp?.response?.portfolios);
    if (resp !== null && resp !== void 0 && resp.isSuccessful && !!(resp !== null && resp !== void 0 && resp.response) && Array.isArray(resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.portfolios)) {
      var _singleElementOfArray2, _resp$response2;
      localStorage.setItem('livable_portfolio_id', ((_singleElementOfArray2 = singleElementOfArray(resp === null || resp === void 0 || (_resp$response2 = resp.response) === null || _resp$response2 === void 0 ? void 0 : _resp$response2.portfolios.filter(portfolio => portfolio.isDefault))) === null || _singleElementOfArray2 === void 0 ? void 0 : _singleElementOfArray2.id) || '');
    }
    if (storeCompany) {
      var _resp$response3;
      await getParent(this).homeDashboardStore.storeNewCompany({
        id: getParent(this).homeDashboardStore.companyAccessId,
        portfolios: resp === null || resp === void 0 || (_resp$response3 = resp.response) === null || _resp$response3 === void 0 ? void 0 : _resp$response3.portfolios.map(portfolio => {
          return _objectSpread(_objectSpread({}, portfolio), {}, {
            properties: portfolio.properties.map(property => {
              return {
                id: property.propertyId,
                accessResponses: property.accessResponses,
                dashboard: _objectSpread({}, property)
              };
            })
          });
        })
      });
    }
    return resp;
  };
});
const transferPortfoliosAsync = createAsync(body => {
  return async function transferPortfolios(options) {
    const resp = await api.Portfolios.transferPortfolios(body, options);
    return resp;
  };
});

// NOTE: NEW multiaccount portfolio apis

const editPropertyPortfoliosRelationshipAsync = createAsync(body => {
  return async function editPropertyPortfoliosRelationship(options) {
    const resp = await api.Portfolios.editPropertyPortfoliosRelationship(body, options);
    return resp;
  };
});
const PortfoliosStore = types.model('PortfoliosStore', {
  getExistingPortfoliosAsync,
  getPortfolioAsync,
  createPortfolioAsync,
  updatePortfolioAsync,
  deletePortfolioAsync,
  getPortfoliosDashboardAsync,
  transferPortfoliosAsync,
  editPropertyPortfoliosRelationshipAsync
});
export const portfolios = types.optional(PortfoliosStore, {});